import { List, ListItem, styled, Typography } from '@mui/material';
import React from 'react';

const StyledListItem = styled(ListItem)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  paddingTop: '0',
  paddingBottom: '10px',
});

const Announcements: React.FC = () => {
  return (
    <>
      <Typography
        variant="subtitle2"
        sx={{
          height: '20px',
          color: '#0047FF',
          margin: 0,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        TIPS AND TRICKS
      </Typography>
      <div style={{ height: 'inherit' }}>
        <List sx={{ height: 'inherit', marginTop: '10px', paddingTop: '0', paddingBottom: '0' }}>
          <StyledListItem>
            <Typography variant="body2">
              <b>💬 Share Conversations with Your Team</b>
            </Typography>
            <Typography variant="body2">
              Quickly create a shareable link to any conversation&mdash;just click “…” in the
              top-right of a past conversation box, enable Shared Link, and copy. Great for sharing
              context or collaborating with teammates.
            </Typography>
          </StyledListItem>
          <StyledListItem>
            <Typography variant="body2">
              <b>↩ Add Line Breaks Without Sending in Nigel&apos;s Chat</b>
            </Typography>
            <Typography variant="body2">
              Need to structure your message or list multiple points? Just press Shift + Enter to
              insert a line break without submitting your chat&mdash;perfect for writing clearer,
              more organized queries.
            </Typography>
          </StyledListItem>
        </List>
      </div>
    </>
  );
};

export default Announcements;
